module.exports = __webpack_public_path__ + "static/media/zawor3.5089921a.svg";